import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import DisabledCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/DisabledCell'
import { useDropShift } from 'modules/shift_management/hooks/useDragAndDrop'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { ShiftsRow } from 'modules/shift_management/lib/types'

import EmployeeDayCell from './EmployeeDayCell'
import WorkAreaDayCell from './WorkAreaDayCell'

export interface DayCellProps {
  date: moment.Moment
  shiftsRow: ShiftsRow
  contractVersions: ContractVersions
}

const DayCell = ({ date, shiftsRow, contractVersions }: DayCellProps) => {
  const [{ view }] = useSchedule()

  const {
    isOver: isOverParent,
    canDrop,
    drop,
  } = useDropShift({
    shiftsRow,
    date,
  })

  if (shiftsRow.isDisabled(view, date)) {
    return <DisabledCell />
  }

  const isFirstDay = view.isDateFirstDayOfPeriod(date)

  return (
    <Box
      flexDirection="column"
      height="full"
      flexGrow
      gap="s4"
      padding="s4"
      paddingBottom="s8"
      ref={drop}
    >
      {view.isByAreas ? (
        <WorkAreaDayCell
          date={date}
          shiftsRow={shiftsRow}
          isFirstDay={isFirstDay}
          contractVersions={contractVersions}
        />
      ) : (
        <EmployeeDayCell
          date={date}
          shiftsRow={shiftsRow}
          isFirstDay={isFirstDay}
          isOver={canDrop && isOverParent}
          contractVersions={contractVersions}
        />
      )}
    </Box>
  )
}

export default observer(DayCell)
